import React, { useMemo } from "react";
import IconPositive from "../../../assets/icon_positive.svg";
import IconNegative from "../../../assets/icon_negative.svg";
import IconParticipants from "../../../assets/Icon_participants.svg";
import { useTranslation } from "react-i18next";
import styles from "./ParticipantsList.module.css";

export interface Participant {
  id: string;
  name: string;
  role: "facilitator" | "participant";
}

type Props = {
  participants: Participant[];
  currentUserId: string;
  votedMap?: Record<string, boolean>; // userId -> проголосовал (true/false)
  classNames?: {
    section?: string;
    count?: string;
    list?: string;
    card?: string;
    cardYou?: string;
    cardFacilitator?: string;
    name?: string;
    badge?: string;
    badgeYou?: string;
    badgeFacilitator?: string;
    voteIcon?: string;
  };
};

const ParticipantsList: React.FC<Props> = ({
  participants,
  currentUserId,
  votedMap = {},
  classNames = {},
}) => {
  const sortedParticipants = useMemo(() => {
    return [...participants].sort((a, b) => {
      if (a.role === 'facilitator' && b.role !== 'facilitator') return -1;
      if (a.role !== 'facilitator' && b.role === 'facilitator') return 1;

      if (a.id === currentUserId) return -1;
      if (b.id === currentUserId) return 1;

      return a.name.localeCompare(b.name);
    });
  }, [participants, currentUserId]);
  const {t} = useTranslation();

  return (
    <div className={styles.participantSection}>
      <div className={styles.participantCount}>
        <img src={IconParticipants} alt="Participants" />
        <span>{t("participants", { count: sortedParticipants.length })}</span>
      </div>

      <div className={styles.participantList}>
        {sortedParticipants.map((p) => {
          const you = p.id === currentUserId;
          const isFs = p.role === "facilitator";
          const voted = votedMap[p.id] ?? false;

          return (
            <div
              key={p.id}
              className={`${styles.participantCard || ""} ${you ? classNames.cardYou || "" : ""} ${isFs ? classNames.cardFacilitator || "" : ""}`}
            >
              <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                <span className={styles.participantName }>{p.name}</span>
                {you && <span className={`${styles.badge} ${styles.badgeYou}`}>{t("yourLabel")}</span>}
                {isFs && <span className={`${styles.badge} ${styles.badgeFacilitator}`}>{t("facilitatorShort")}</span>}
              </div>
              <img
                src={voted ? IconPositive : IconNegative}
                alt=""
                className={styles.voteStatusIcon}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ParticipantsList;
